// extracted by mini-css-extract-plugin
export var category = "RelatedGuides-module--category--8786c";
export var guide = "RelatedGuides-module--guide--fd9aa";
export var more = "RelatedGuides-module--more--d43e6";
export var related_links = "RelatedGuides-module--related_links--a5b54";